import { render, staticRenderFns } from "./IconMAX.vue?vue&type=template&id=19a889aa&"
import script from "./IconMAX.vue?vue&type=script&lang=ts&"
export * from "./IconMAX.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports